import { UserExperienceService } from './user-experience.service';

export default angular
  .module('sfMobile.services.user-experience', [
    'sfMobile.constants.user-experience',
  ])
  .factory('userExperienceService', UserExperienceService).name;
